import styled from '@emotion/styled';
import _ from 'lodash';
import React, { useState, useEffect } from 'react';

const ScrollBox = styled.div`
  border: 1px solid #333333;
  padding: 1rem;
  height: 18rem;
  width: 23.125rem;
  overflow-y: scroll;
`;

const TermsScrollBox = () => (
  <ScrollBox>
    <p>Your registration information will be added into our warranty database.</p>
    <p>
      From time to time, Owens Corning might want to use that database to contact you with other information or product
      offers.
    </p>
    <p>
      Also, in order to help other homeowners pick their new roof color, we would like to add your address and shingle
      information to an on-line map so other homeowners can see their shingle choice on an actual house.
    </p>
    <p>No other personal information will be shared – just your address and product/color name</p>
  </ScrollBox>
);

export default TermsScrollBox;
